import React from 'react';
import just_gamers_img from "../Assets/Images/images/just_gamers_img.png";
import gamers_circle_line from "../Assets/Images/images/gamers_circle_line.png";
import gamers_circle_shape from "../Assets/Images/images/gamers_circle_shape.png";
import just_gamers_chart from "../Assets/Images/images/just_gamers_chart.png";
import '../CSS/new.css';

const TopGames = ({data}) => {
  // const data = []; // Replace with your actual data

  console.log(data)

  return (
    <section className="just-gamers-area just-gamers-bg pt-[100px] pb-[100px]">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap h-[25rem]">
          <div className="w-full lg:w-5/12 xl:w-5/12 md:w-10/12">
            <div className="section-title title-style-three white-title mb-[70px]">
              <h2 className="text-white text-4xl font-bold">
                TOP THREE <span className="text-primary">GAMES</span>
              </h2>
            </div>
            <div className="just-gamers-list">
              <ul>
                {data?.map((value, key) => (
                  <li key={key} className="flex items-center mb-4">
                    <div
                      className="just-gamers-list-icon cursor-pointer"
                      onClick={() => {
                        window.location.href = `${value.game}`;
                      }}
                    >
                      <img
                        src={value.image}
                        alt="ImgSrc"
                        className="h-20 w-20"
                      />
                    </div>
                    <div
                      className="just-gamers-list-content flex-1 ml-4 cursor-pointer"
                      onClick={() => {
                        window.location.href = `${value.game}`;
                      }}
                    >
                      <h5 className="text-white text-lg font-bold uppercase select-none">
                        {value.name}
                      </h5>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="w-full lg:w-7/12 xl:w-7/12 hidden lg:block">
            <div className="just-gamers-img relative h-full">
              <img
                src={just_gamers_img}
                alt=""
                className="just-gamers-character"
              />
              <div className="just-gamers-circle-shape absolute bottom-[15rem] left-[10rem]">
                <img src={gamers_circle_line} alt="" />
                <img
                  src={gamers_circle_shape}
                  alt=""
                  className="rotateme absolute top-0 left-0"
                />
              </div>
              <img
                src={just_gamers_chart}
                alt=""
                className="gamers-chart-shape absolute bottom-0 right-0"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopGames;